module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Velkommen til Memolife Partners","alreadyMember":"Allerede medlem?","alreadyMemberLogin":"Logg inn","emailSignupButton":"Meld deg inn","facebookSignupButton":"Meld deg inn med Facebook"},"en":{"title":"Welcome to Memolife Partners","alreadyMember":"Already a member?","alreadyMemberLogin":"Login","emailSignupButton":"Signup","facebookSignupButton":"Signup with Facebook"}}')
  delete Component.options._Ctor
}
